// extracted by mini-css-extract-plugin
export default {"ProviderImg":"CoursePicture_ProviderImg__41R5u","PictureWrapper":"CoursePicture_PictureWrapper__gWKOD"};